import { render, staticRenderFns } from "./create-category.vue?vue&type=template&id=0f857ce5&"
import script from "./create-category.vue?vue&type=script&lang=js&"
export * from "./create-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports